import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/authz/capabilities", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(capability, requestOptions) {
  return __request__("GET", `/authz/capabilities/${capability}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function entityCapabilityPermissions(capability, entity, requestOptions) {
  return __request__("GET", `/authz/capabilities/${capability}/${entity}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
